import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import './style/main.styl'
import wysiwyg from 'vue-wysiwyg'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(wysiwyg, {
  maxHeight: '500px',

})

Vue.use(Vuetify)
Vue.use(DatetimePicker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  vuetify: new Vuetify({ iconfont: 'fa' }),
}).$mount('#app')
